import { ReactElement, useMemo } from 'react';
import { OperationButtonProps } from '../types';
import { useTranslation } from 'react-i18next';
import { FanRCIcon, SnowflakeIcon } from '~/icons';
import { Button } from '~/components';
import { colors } from '~/styles/remoteControlColors';
import Skeleton from 'react-loading-skeleton';
import { OperationButtonLoading } from '../styles';

export function OperationButton({
  currentOperation,
  disabled,
  onClickModality,
  operation,
  loading,
}: Readonly<OperationButtonProps>): ReactElement {
  const { t } = useTranslation();

  const Icon = useMemo(() => {
    if (operation === 'cool') return SnowflakeIcon;
    return FanRCIcon;
  }, [operation]);

  function onClick(): void {
    if (!disabled) {
      onClickModality();
    }
  }

  if (loading) {
    return (
      <OperationButtonLoading>
        <Skeleton height="12px" />
      </OperationButtonLoading>
    );
  }

  return (
    <Button
      type="button"
      variant={currentOperation === operation && !disabled ? 'rc-blue' : 'rc-grey'}
      onClick={onClick}
      {...(disabled && { style: { cursor: 'not-allowed' } })}
    >
      <div style={{
        display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center',
      }}
      >
        <Icon color={currentOperation === operation && !disabled ? colors.White : colors.Grey400} size="24" />
        <span style={{ fontWeight: '600', fontSize: '14px' }}>{t(operation === 'cool' ? 'resfriar' : 'ventilar')}</span>
      </div>
    </Button>
  );
}
